module.exports = __webpack_public_path__ + "img/logo-levis.9759cc6d.png";